import React, { useState, useEffect } from 'react';
import { supabase } from '../supabase';

const C = {
  purple:"#691FB1", purpleLight:"#EDE7F6",
  green:"#27AE60", greenLight:"#EAFAF1",
  amber:"#F39C12", amberLight:"#FEF9E7",
  red:"#E74C3C", redLight:"#FDEDEC",
  blue:"#57B1DD", blueLight:"#E5F7FF",
  white:"#FFFFFF", bg:"#F7F5FC",
  text:"#1A1A2E", textMid:"#4A4A6A", textLight:"#8888AA",
  border:"#E4DEFA",
};

const NATUREZA = ["Incidente ferroviário afetando segurança","Acidente — colisão","Acidente — descarrilamento","Acidente — passagem de nível","Acidente — atropelamento","Acidente — incêndio","Outra ocorrência"];
const LOCAIS = ["Lisboa","Coimbra","Entroncamento","Porto","Outro"];
const SST = ["Aguarda contacto","Em articulação","Parecer recebido"];

const FInput = ({value,onChange,placeholder,type="text"}) =>
  <input type={type} value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder}
    style={{width:"100%",padding:"8px 10px",border:`1px solid #E4DEFA`,borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/>;

const FSelect = ({value,onChange,options}) =>
  <select value={value||""} onChange={e=>onChange(e.target.value)}
    style={{width:"100%",padding:"8px 10px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none"}}>
    <option value="">Seleccionar...</option>
    {options.map(o=><option key={o} value={o}>{o}</option>)}
  </select>;

const FTextarea = ({value,onChange,placeholder,rows=3}) =>
  <textarea value={value||""} onChange={e=>onChange(e.target.value)} placeholder={placeholder} rows={rows}
    style={{width:"100%",padding:"8px 10px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",resize:"vertical",boxSizing:"border-box"}}/>;

const Row = ({label,note,children}) =>
  <div style={{padding:"10px 0",borderBottom:"1px solid #E4DEFA"}}>
    <div style={{fontSize:13,fontWeight:600,color:"#1A1A2E",marginBottom:6}}>{label}</div>
    {note&&<div style={{fontSize:11,color:"#8888AA",marginBottom:6,fontStyle:"italic"}}>i {note}</div>}
    {children}
  </div>;

const BtnToggle = ({options,value,onChange,colors}) =>
  <div style={{display:"flex",gap:10}}>
    {options.map(op=>{
      const active = value===op;
      const col = colors?.[op]||{border:"#691FB1",bg:"#EDE7F6",text:"#691FB1"};
      return <button key={op} type="button" onClick={()=>onChange(op)}
        style={{flex:1,padding:"9px",border:`2px solid ${active?col.border:"#E4DEFA"}`,borderRadius:8,background:active?col.bg:"white",color:active?col.text:"#8888AA",fontSize:13,cursor:"pointer",fontWeight:700,fontFamily:"system-ui"}}>
        {op}
      </button>;
    })}
  </div>;

const SECTIONS = ["1. Colaborador","2. Incidente","3. Acionamento","4. Consulta inicial","5. Decisão e seguimento"];

export default function FichaAcolhimentoIP({projectId,projectName,codigoCaso,onClose}){
  const [step,setStep] = useState("check");
  const [ficha,setFicha] = useState(null);
  const [loading,setLoading] = useState(true);
  const [password,setPassword] = useState("");
  const [newPass,setNewPass] = useState("");
  const [newPass2,setNewPass2] = useState("");
  const [error,setError] = useState("");
  const [saving,setSaving] = useState(false);
  const [saved,setSaved] = useState(false);
  const [section,setSection] = useState(0);

  useEffect(()=>{loadFicha();},[projectId]);

  const hashPassword = async (pass) => {
    const enc = new TextEncoder();
    const buf = await crypto.subtle.digest("SHA-256", enc.encode(pass+"workwell_ip_2026"));
    return Array.from(new Uint8Array(buf)).map(b=>b.toString(16).padStart(2,"0")).join("");
  };

  const loadFicha = async () => {
    setLoading(true);
    const {data} = await supabase.from("ip_fichas_acolhimento").select("id,codigo_caso,password_hash,status,signed_at").eq("project_id",projectId).single();
    if(data){setFicha(data);setStep("unlock");}
    else{setFicha({project_id:projectId,codigo_caso:codigoCaso});setStep("create");}
    setLoading(false);
  };

  const createFicha = async () => {
    if(!newPass||newPass.length<4){setError("Password deve ter pelo menos 4 caracteres");return;}
    if(newPass!==newPass2){setError("As passwords nao coincidem");return;}
    const hash = await hashPassword(newPass);
    const {data:ins} = await supabase.from("ip_fichas_acolhimento").insert({project_id:projectId,codigo_caso:ficha.codigo_caso,password_hash:hash,status:"rascunho"}).select().single();
    if(ins){setFicha(ins);setStep("form");setError("");}
  };

  const unlockFicha = async () => {
    const hash = await hashPassword(password);
    if(hash!==ficha.password_hash){setError("Password incorrecta");return;}
    const {data} = await supabase.from("ip_fichas_acolhimento").select("*").eq("id",ficha.id).single();
    if(data){setFicha(data);setStep("form");setError("");}
  };

  const f = (k,v) => setFicha(b=>({...b,[k]:v}));

  const saveFicha = async () => {
    setSaving(true);
    const {password_hash,...d} = ficha;
    await supabase.from("ip_fichas_acolhimento").update({...d,updated_at:new Date().toISOString()}).eq("id",ficha.id);
    setSaved(true);setTimeout(()=>setSaved(false),2000);
    setSaving(false);
  };

  const signFicha = async () => {
    const {data:{session}} = await supabase.auth.getSession();
    f("status","assinado");f("signed_at",new Date().toISOString());f("signed_by",session?.user?.email);
    await saveFicha();
  };

  if(loading) return(
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000}}>
      <div style={{background:"white",borderRadius:12,padding:32,color:"#691FB1",fontFamily:"system-ui"}}>A carregar ficha...</div>
    </div>
  );

  const modalWrap = (children) => (
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,backdropFilter:"blur(4px)"}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()}>{children}</div>
    </div>
  );

  if(step==="create") return modalWrap(
    <div style={{background:"white",borderRadius:16,padding:32,width:420,boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:40,marginBottom:8}}>locked</div>
        <h2 style={{margin:0,color:"#691FB1",fontSize:20,fontWeight:700}}>Criar ficha protegida</h2>
        <p style={{margin:"8px 0 0",fontSize:13,color:"#4A4A6A"}}>Define uma password para proteger os dados do colaborador IP</p>
      </div>
      <div style={{background:"#EDE7F6",borderRadius:9,padding:12,marginBottom:16,fontSize:12,color:"#691FB1"}}>
        <strong>Codigo do caso:</strong> {ficha?.codigo_caso}
        <div style={{fontSize:11,color:"#4A4A6A",marginTop:4}}>Guarda este codigo para referencia futura</div>
      </div>
      <div style={{display:"grid",gap:12}}>
        <div><label style={{fontSize:11,fontWeight:600,color:"#8888AA",display:"block",marginBottom:4}}>Password de acesso</label>
          <input type="password" value={newPass} onChange={e=>setNewPass(e.target.value)} placeholder="Minimo 4 caracteres"
            style={{width:"100%",padding:"9px 11px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/></div>
        <div><label style={{fontSize:11,fontWeight:600,color:"#8888AA",display:"block",marginBottom:4}}>Confirmar password</label>
          <input type="password" value={newPass2} onChange={e=>setNewPass2(e.target.value)} placeholder="Repetir password"
            style={{width:"100%",padding:"9px 11px",border:"1px solid #E4DEFA",borderRadius:7,fontSize:13,fontFamily:"system-ui",outline:"none",boxSizing:"border-box"}}/></div>
        {error&&<div style={{fontSize:12,color:"#E74C3C",background:"#FDEDEC",padding:"8px 12px",borderRadius:7}}>Aviso: {error}</div>}
      </div>
      <div style={{display:"flex",gap:10,marginTop:20}}>
        <button onClick={onClose} style={{flex:1,padding:10,border:"1px solid #E4DEFA",borderRadius:8,background:"white",color:"#4A4A6A",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>Cancelar</button>
        <button onClick={createFicha} style={{flex:2,padding:10,border:"none",borderRadius:8,background:"#691FB1",color:"white",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>Criar ficha protegida</button>
      </div>
    </div>
  );

  if(step==="unlock") return modalWrap(
    <div style={{background:"white",borderRadius:16,padding:32,width:380,boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}}>
      <div style={{textAlign:"center",marginBottom:24}}>
        <div style={{fontSize:40,marginBottom:8}}>locked</div>
        <h2 style={{margin:0,color:"#691FB1",fontSize:20,fontWeight:700}}>Ficha protegida</h2>
        <p style={{margin:"8px 0 0",fontSize:13,color:"#4A4A6A"}}>Introduz a password para aceder aos dados</p>
        <div style={{marginTop:8,fontSize:12,color:"#691FB1",fontWeight:600}}>Caso: {ficha?.codigo_caso}</div>
        {ficha?.status==="assinado"&&<div style={{marginTop:6,background:"#EAFAF1",color:"#27AE60",borderRadius:6,padding:"4px 10px",fontSize:11,fontWeight:700,display:"inline-block"}}>Assinado</div>}
      </div>
      <input type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&unlockFicha()} placeholder="Password"
        style={{width:"100%",padding:"12px",border:`1px solid ${error?"#E74C3C":"#E4DEFA"}`,borderRadius:8,fontSize:14,fontFamily:"system-ui",outline:"none",boxSizing:"border-box",textAlign:"center",letterSpacing:4}}/>
      {error&&<div style={{fontSize:12,color:"#E74C3C",marginTop:8,textAlign:"center"}}>{error}</div>}
      <div style={{display:"flex",gap:10,marginTop:16}}>
        <button onClick={onClose} style={{flex:1,padding:10,border:"1px solid #E4DEFA",borderRadius:8,background:"white",color:"#4A4A6A",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>Cancelar</button>
        <button onClick={unlockFicha} style={{flex:2,padding:10,border:"none",borderRadius:8,background:"#691FB1",color:"white",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>Desbloquear</button>
      </div>
    </div>
  );

  return(
    <div style={{position:"fixed",inset:0,background:"rgba(26,26,46,0.6)",display:"flex",alignItems:"center",justifyContent:"center",zIndex:1000,backdropFilter:"blur(4px)"}} onClick={onClose}>
      <div style={{background:"white",borderRadius:16,width:680,maxHeight:"90vh",display:"flex",flexDirection:"column",overflow:"hidden",boxShadow:"0 20px 56px rgba(0,0,0,0.22)",fontFamily:"system-ui"}} onClick={e=>e.stopPropagation()}>

        <div style={{background:"#691FB1",padding:"16px 24px",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <h2 style={{margin:0,color:"white",fontSize:18,fontWeight:700}}>Ficha de Acolhimento IP</h2>
            <p style={{margin:"3px 0 0",fontSize:12,color:"rgba(255,255,255,0.75)"}}>{projectName} - Caso: {ficha?.codigo_caso}</p>
          </div>
          <div style={{display:"flex",alignItems:"center",gap:10}}>
            {ficha?.status==="assinado"?<span style={{background:"#27AE60",color:"white",borderRadius:6,padding:"4px 12px",fontSize:12,fontWeight:700}}>Assinado</span>:<span style={{background:"#FEF9E7",color:"#F39C12",borderRadius:6,padding:"4px 12px",fontSize:12,fontWeight:700}}>Rascunho</span>}
            <button onClick={onClose} style={{background:"none",border:"none",color:"rgba(255,255,255,0.7)",fontSize:22,cursor:"pointer"}}>x</button>
          </div>
        </div>

        <div style={{padding:"10px 24px",background:"#EDE7F6",borderBottom:"1px solid #E4DEFA"}}>
          <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
            {SECTIONS.map((s,i)=><button key={i} onClick={()=>setSection(i)} style={{background:section===i?"#691FB1":"white",border:`1px solid ${section===i?"#691FB1":"#E4DEFA"}`,borderRadius:5,color:section===i?"white":"#8888AA",padding:"3px 10px",fontSize:10,cursor:"pointer",fontFamily:"system-ui",fontWeight:section===i?700:400}}>{s}</button>)}
          </div>
        </div>

        <div style={{flex:1,overflowY:"auto",padding:"20px 24px"}}>

          {section===0&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>1. Dados do colaborador</h3>
            <Row label="Nome completo"><FInput value={ficha?.nome_colaborador} onChange={v=>f("nome_colaborador",v)} placeholder="Nome completo do colaborador IP"/></Row>
            <Row label="Email"><FInput type="email" value={ficha?.email_colaborador} onChange={v=>f("email_colaborador",v)} placeholder="email@ip.pt"/></Row>
            <Row label="Contacto telefónico"><FInput value={ficha?.contacto} onChange={v=>f("contacto",v)} placeholder="Ex: 912 345 678"/></Row>
            <Row label="Género">
              <BtnToggle options={["Masculino","Feminino","Outro"]} value={ficha?.genero||""} onChange={v=>f("genero",v)}
                colors={{Masculino:{border:"#57B1DD",bg:"#E5F7FF",text:"#1A6FA0"},Feminino:{border:"#FF357B",bg:"#FFF0F5",text:"#BE1356"},Outro:{border:"#691FB1",bg:"#EDE7F6",text:"#691FB1"}}}/>
            </Row>
            <Row label="Faixa etária">
              <FSelect value={ficha?.faixa_etaria} onChange={v=>f("faixa_etaria",v)} options={["18-25 anos","26-35 anos","36-45 anos","46-55 anos","56-65 anos","65+ anos"]}/>
            </Row>
            <Row label="Categoria profissional"><FInput value={ficha?.categoria_profissional} onChange={v=>f("categoria_profissional",v)} placeholder="Ex: Maquinista, Chefe de Estacao, Tecnico de Via"/></Row>
            <Row label="Área geográfica"><FSelect value={ficha?.local_trabalho} onChange={v=>f("local_trabalho",v)} options={LOCAIS}/></Row>
          </div>}

          {section===1&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>2. Dados do incidente</h3>
            <Row label="Data do incidente"><FInput type="date" value={ficha?.data_incidente} onChange={v=>f("data_incidente",v)}/></Row>
            <Row label="Natureza da ocorrencia"><FSelect value={ficha?.natureza_incidente} onChange={v=>f("natureza_incidente",v)} options={NATUREZA}/></Row>
            <Row label="O colaborador foi retirado de funcoes?">
              <BtnToggle options={["Sim","Nao"]} value={ficha?.retirado_funcoes===true?"Sim":ficha?.retirado_funcoes===false?"Nao":""} onChange={v=>f("retirado_funcoes",v==="Sim")}
                colors={{Sim:{border:"#E74C3C",bg:"#FDEDEC",text:"#E74C3C"},Nao:{border:"#27AE60",bg:"#EAFAF1",text:"#27AE60"}}}/>
            </Row>
            <Row label="Descricao da ocorrencia" note="Confidencial - nao partilhar com IP">
              <FTextarea value={ficha?.descricao_incidente} onChange={v=>f("descricao_incidente",v)} placeholder="Descreve sucintamente o que aconteceu..." rows={4}/>
            </Row>
          </div>}

          {section===2&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>3. Acionamento</h3>
            <Row label="Data e hora do acionamento"><FInput type="datetime-local" value={ficha?.data_acionamento?.slice(0,16)} onChange={v=>f("data_acionamento",v)}/></Row>
            <Row label="Quem acionou (IP)"><FInput value={ficha?.quem_acionou} onChange={v=>f("quem_acionou",v)} placeholder="Ex: Cristina Barbosa"/></Row>
            <Row label="Quem atendeu (Workwell)"><FInput value={ficha?.quem_atendeu} onChange={v=>f("quem_atendeu",v)} placeholder="Ex: Elisabete Madureira"/></Row>
            <Row label="Modalidade pretendida">
              <BtnToggle options={["Online","Presencial"]} value={ficha?.modalidade==="online"?"Online":ficha?.modalidade==="presencial"?"Presencial":""} onChange={v=>f("modalidade",v.toLowerCase())}
                colors={{Online:{border:"#57B1DD",bg:"#E5F7FF",text:"#1A6FA0"},Presencial:{border:"#691FB1",bg:"#EDE7F6",text:"#691FB1"}}}/>
            </Row>
          </div>}

          {section===3&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>4. Consulta inicial de acolhimento</h3>
            <div style={{background:"#E5F7FF",borderRadius:8,padding:"10px 14px",fontSize:12,color:"#1A6FA0",marginBottom:16}}>
              SLA: 48h apos acionamento - Conduzida pela Elisabete (30-50 min) - Faturada como tipologia B autonoma
            </div>
            <Row label="Data da consulta inicial"><FInput type="date" value={ficha?.data_consulta_inicial} onChange={v=>f("data_consulta_inicial",v)}/></Row>
            <Row label="Duracao (minutos)"><FInput type="number" value={ficha?.duracao_consulta} onChange={v=>f("duracao_consulta",Number(v))} placeholder="Ex: 45"/></Row>
            <Row label="Observacoes clinicas" note="Confidencial - nao partilhar com IP">
              <FTextarea value={ficha?.observacoes_consulta} onChange={v=>f("observacoes_consulta",v)} placeholder="Estado emocional, contexto, necessidades identificadas..." rows={5}/>
            </Row>
          </div>}

          {section===4&&<div>
            <h3 style={{margin:"0 0 16px",color:"#691FB1",fontSize:16,fontWeight:700}}>5. Decisao e seguimento</h3>
            <Row label="Decisao do colaborador">
              <BtnToggle options={["Aceita continuidade","Recusa"]} value={ficha?.decisao_colaborador||""}  onChange={v=>f("decisao_colaborador",v)}
                colors={{"Aceita continuidade":{border:"#27AE60",bg:"#EAFAF1",text:"#27AE60"},Recusa:{border:"#E74C3C",bg:"#FDEDEC",text:"#E74C3C"}}}/>
            </Row>
            <Row label="Estado articulacao SST / Medicina do Trabalho IP"><FSelect value={ficha?.estado_sst} onChange={v=>f("estado_sst",v)} options={SST}/></Row>
            <Row label="Psicologo designado"><FInput value={ficha?.psicologo_designado} onChange={v=>f("psicologo_designado",v)} placeholder="Nome do psicologo da pool (ou Nao se aplica)"/></Row>
            <Row label="Data de designacao"><FInput type="date" value={ficha?.data_designacao} onChange={v=>f("data_designacao",v)}/></Row>
          </div>}

        </div>

        <div style={{padding:"14px 24px",borderTop:"1px solid #E4DEFA",display:"flex",gap:10,alignItems:"center"}}>
          <button onClick={()=>setSection(s=>Math.max(0,s-1))} disabled={section===0}
            style={{background:"#F7F5FC",border:"1px solid #E4DEFA",borderRadius:7,color:section===0?"#8888AA":"#691FB1",padding:"8px 16px",fontSize:13,cursor:section===0?"not-allowed":"pointer",fontFamily:"system-ui"}}>
            Anterior
          </button>
          {section<4&&<button onClick={()=>setSection(s=>s+1)}
            style={{background:"#EDE7F6",border:"1px solid #691FB1",borderRadius:7,color:"#691FB1",padding:"8px 16px",fontSize:13,cursor:"pointer",fontFamily:"system-ui",fontWeight:600}}>
            Proxima
          </button>}
          <div style={{flex:1}}/>
          {saved&&<span style={{fontSize:12,color:"#27AE60",fontWeight:600}}>Guardado!</span>}
          <button onClick={saveFicha} disabled={saving}
            style={{background:"white",border:"1px solid #E4DEFA",borderRadius:7,color:"#4A4A6A",padding:"8px 16px",fontSize:13,cursor:"pointer",fontFamily:"system-ui"}}>
            {saving?"A guardar...":"Guardar"}
          </button>
          {ficha?.status!=="assinado"&&<button onClick={signFicha}
            style={{background:"#691FB1",border:"none",borderRadius:7,color:"white",padding:"8px 16px",fontSize:13,fontWeight:700,cursor:"pointer",fontFamily:"system-ui"}}>
            Assinar Ficha
          </button>}
        </div>
      </div>
    </div>
  );
}
